import { downloadCanvas, getCanvasBase64 } from 'shared-base';
import { sendToUnity } from '../utils/bridge';

export const handleCustomEvent = (message: string, data: Json) => {
  let handled = false;

  try {
    switch (message) {
      case 'DownloadScreenshot':
        const { generatorId } = data;
        downloadCanvas(generatorId + '.png');
        handled = true;
        break;
      case 'GetScreenshot':
        const base64 = getCanvasBase64();
        sendToUnity(message, base64);
        handled = true;
        break;
    }
  } catch (e) {}

  return handled;
};
